import script from "./Vipmessage.vue?vue&type=script&setup=true&lang=js"
export * from "./Vipmessage.vue?vue&type=script&setup=true&lang=js"

import "./Vipmessage.vue?vue&type=style&index=0&id=9376319e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9376319e"]])

export default __exports__